import { styled, Typography } from '@mui/material';

export const EmailOTPTitle = styled(Typography)(({ theme }) => ({
  textAlign: 'center',
  ...theme.typography.h3,
  [theme.breakpoints.up('lg')]: {
    ...theme.typography.h2,
    textAlign: 'left',
  },
}));

export const EmailOTPTitleHighlight = styled(Typography)(({ theme }) => ({
  ...theme.typography.h3,
  textAlign: 'center',
  color: theme.palette.primaries[400],
  [theme.breakpoints.up('lg')]: {
    ...theme.typography.h2,
    textAlign: 'left',
  },
}));

export const EmailOTPDescription = styled(Typography)(({ theme }) => ({
  ...theme.typography.body2,
  textAlign: 'center',
  color: theme.palette.neutral[800],
  marginBottom: theme.spacing(1),
  [theme.breakpoints.up('lg')]: {
    ...theme.typography.body1,
    textAlign: 'left',
    marginBottom: theme.spacing(2),
  },
}));
